module.exports = __webpack_public_path__ + "static/media/599.767(16).a7a7923b.pdf";